module.exports = __webpack_public_path__ + "static/media/custom-05.05ab58f2.jpg";